import { AccordionSummary } from '@mui/material'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import Badge from '@mui/material/Badge'
import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import { colors } from '@theme/variables'

export const OuterFilterBox = styled(Box)<{ $active: boolean }>`
  border: 1px solid ${({ $active, theme }) => ($active ? theme.palette.primary.main : colors.lightGrey)};
  border-radius: 4px;
  padding: 20px;
  background-color: ${colors.white};
  flex-grow: 0;
  ${({ $active }: { $active?: boolean }) =>
    $active
      ? `
          box-shadow: 0px 0px 12px 2px #a5bcc433;
        `
      : ''}
`
export const FilterTitleBox = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const FilterAccordionTitle = styled(Typography)`
  display: flex;
  align-items: center;
`
export const FilterBadge = styled(Badge)`
  margin-left: 7px;
  margin-right: 10px;
`
export const FilterSkeletonBox = styled(Box)`
  min-height: 120px;
  padding: 20px;
  border: 1px solid ${colors.lightGrey};
  border-radius: 4px;

  & + & {
    margin-top: 20px;
  }
`

export const FilterSkeleton = styled(Skeleton)`
  width: 100%;
  height: 20px;
`

export const FilterSearchInput = styled(TextField)`
  margin-bottom: 16px;
  width: 100%;

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline,
  & .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${colors.primaryDark};
  }

  & .MuiOutlinedInput-root {
    height: 27px;
    border-radius: 0;
  }
` as typeof TextField

export const ShowMoreWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 12px;
  gap: 10px;
  cursor: pointer;
`

export const BorderlessAccordion = styled(Accordion)`
  box-shadow: none;
`

export const CustomAccordionSummary = styled(AccordionSummary)`
  padding: 0;
  align-items: center;
  flex-direction: row;
`

export const CustomAccordionDetails = styled(AccordionDetails)`
  padding: 0;
`
export const DateFilterOptionWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const FilterSectionAccordionSummary = styled(AccordionSummary)`
  & .MuiAccordionSummary-expandIconWrapper {
    transform: rotate(0deg);
    &.Mui-expanded {
      transform: rotate(180deg);
    }
  }
`
